import { useEffect, useState } from "react";
import { copyTextToClipboard } from "@/lib/clipboard/copyTextToClipboard";
import { cn } from "@/utils/cn";

interface InvoiceIdCellProps {
  id: string;
  invoiceNumber?: string | null;
  /** Accessible name for the copied resource (default: Invoice number). */
  resourceLabel?: string;
}

export function InvoiceIdCell({
  id,
  invoiceNumber,
  resourceLabel = "Invoice number",
}: InvoiceIdCellProps) {
  const [copied, setCopied] = useState(false);
  const number = invoiceNumber?.trim();
  const display = number || id;

  useEffect(() => {
    if (!copied) return;
    const t = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(t);
  }, [copied]);

  const onCopy = async () => {
    const ok = await copyTextToClipboard(display);
    if (ok) setCopied(true);
  };

  return (
    <button
      type="button"
      className={cn(
        "invoice-id-copy-text cell-name block truncate tabular-nums",
        copied && "is-copied",
      )}
      title={copied ? "Copied!" : `Click to copy: ${display}`}
      aria-label={copied ? `${resourceLabel} copied` : `Copy ${resourceLabel} ${display}`}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => void onCopy()}
    >
      {copied ? "Copied!" : display}
    </button>
  );
}
